// extracted by mini-css-extract-plugin
export default {"container":"Tl-z","freeShip":"Ul-z","privacy":"Vl-z"};